module.exports = __webpack_public_path__ + "img/icon-next.f43488f2.svg";